const { createContext } = require('react')

export const CompanyContext = createContext()
